import { useMemo } from "react";
import { ArrowLeft, X } from "react-feather";
import { useDispatch, useSelector } from "react-redux";

import logoBlack from "@kikoff/components/src/v1/brand/images/logo_black.svg";
import ContainerButton from "@kikoff/components/src/v1/buttons/ContainerButton";
import KLink from "@kikoff/components/src/v1/navigation/KLink";

import Line from "@component/line";
import { selectCreditAccount } from "@feature/credit_line";
import { consumeState } from "@feature/page";
import { isWebview } from "@util/mobile";

import styles from "./styles.module.scss";

interface StreamlinedHeaderProps {
  displayBackButton?: boolean;
  onBack?: () => void;
  displayCloseButton?: boolean;
  page?: any;
}

function StreamlinedHeader({
  displayBackButton,
  onBack,
  displayCloseButton,
  page,
}: StreamlinedHeaderProps) {
  const dispatch = useDispatch();
  const creditLine = useSelector(selectCreditAccount());

  const returnRoute = useMemo(() => dispatch(consumeState("returnRoute")), []);

  displayBackButton = page && displayBackButton;
  displayCloseButton =
    page && (isWebview || creditLine?.closedAt) && displayCloseButton;

  return (
    <section className={styles["streamlined-header"]}>
      {!isWebview && (
        <div className={styles["logo-wrapper"]}>
          <img
            className={styles["streamlined-logo"]}
            src={logoBlack.src}
            alt="Kikoff logo"
          />
          <Line />
        </div>
      )}
      {(displayBackButton || displayCloseButton) && (
        <div className={styles["button-row"]}>
          <div className={styles["button-alignment-wrapper"]}>
            {displayBackButton && (
              <ContainerButton
                inline
                onClick={() => {
                  if (onBack) {
                    onBack();
                    return;
                  }

                  page.controller.prev();
                }}
              >
                <ArrowLeft className={styles.back} />
              </ContainerButton>
            )}
          </div>

          <div className={styles["button-alignment-wrapper"]}>
            {displayCloseButton && (
              <KLink href={returnRoute || "/dashboard"} variant="unstyled">
                <X />
              </KLink>
            )}
          </div>
        </div>
      )}
    </section>
  );
}

export default StreamlinedHeader;
